import { render, staticRenderFns } from "./mySalary.vue?vue&type=template&id=206a323a&scoped=true"
import script from "./mySalary.vue?vue&type=script&lang=js"
export * from "./mySalary.vue?vue&type=script&lang=js"
import style0 from "./mySalary.vue?vue&type=style&index=0&id=206a323a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206a323a",
  null
  
)

export default component.exports